// Phase P.3 Item 5 — Details-to-follow badge.
//
// Rendered next to a customer's display name whenever the backend reports
// `details_pending === true` (phone captured, but company_name and/or a
// receiving email are still missing). Small, red, clearly a to-do marker
// but not shouty enough to feel like an error state.
//
// Two variants:
//   - <DetailsPendingBadge />       — full "Details to follow" pill
//   - <DetailsPendingDot />         — 8px red dot for calendar/jobs tiles
//                                     where horizontal room is tight

export function DetailsPendingBadge({ className = "", testId = "customer-details-pending-badge" }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border border-red-300 bg-red-50 text-red-700 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider mono ${className}`}
      data-testid={testId}
      title="Missing company or email — chase up when the customer replies"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-red-500" aria-hidden />
      Details to follow
    </span>
  );
}

export function DetailsPendingDot({ className = "", testId = "customer-details-pending-dot" }) {
  return (
    <span
      className={`inline-block h-2 w-2 rounded-full bg-red-500 shadow-[0_0_0_2px_rgba(255,255,255,0.9)] ${className}`}
      data-testid={testId}
      title="Customer details still to follow"
      aria-label="Customer details still to follow"
    />
  );
}
